import { endPoints } from '../configs/endPoints'
import { 
  INews, 
  IPermissoesResponse, 
  IUser, 
  ISanitizationUser, 
  IBureauUser ,
  IBureauUserRequest,
  IUserContact,
  IMFARequest,
  IUserMigrationStatus
} from '../interfaces/user'

import Cookie from 'js-cookie'
import Constants from '@/configs/constants'
import { IGenericResponse } from '@/interfaces/generic'
import { jwtDecode } from "jwt-decode";

import { API } from '../utils/fetcher'
import { API_PEDIDOS } from '@/utils/pedidos-fetcher'
import { API_DOMAIN_ACCESS } from '@/utils/domain-access-fetcher'

export async function getUser(): Promise<IUser> {
  const data = await API.get<IUser>(endPoints.userData)

  return data
}

export async function getNews(): Promise<INews> {
  const data = await API.get<INews>(endPoints.news)

  return data
}

export async function getUserPermissions({
  idEmpregador,
  sistema
}: {
  idEmpregador: string
  sistema: string
}): Promise<IPermissoesResponse> {
  const data = await API_PEDIDOS.get<IPermissoesResponse>(
    endPoints.userPermissoes,
    { idEmpregador, sistema }
  )

  return data
}

export function getUserIdByToken() {

  const isAuthenticated = Boolean(Cookie.get(Constants.TOKEN_STORAGE_KEY))

  if(!isAuthenticated)
    return null

  const token = Cookie.get(Constants.TOKEN_STORAGE_KEY)

  const decoded = jwtDecode(token);
  const userId = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];

  return userId
}

export async function getUserSanitization(): Promise<ISanitizationUser> {

  const endpointSanitization = endPoints.obterSanitizacaoDoUsuario.replace(
    '{id}',
    getUserIdByToken
  )

  const data = await API_DOMAIN_ACCESS.get<ISanitizationUser>(
    endpointSanitization
  )

  return data
}

export async function increaseTriesOfSanitization() {
  const endpointEditarItem = endPoints.atualizarTentativaDeSanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.patch<IGenericResponse>(
    endpointEditarItem
  )

  return response
}

export async function updateRegisterData(data: IBureauUserRequest) {
  const endpointEditarItem = endPoints.atualizarDadosCadastraisDoUsuarioParaSanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.patch<IGenericResponse>(
    endpointEditarItem,
    data
  )

  return response
}

export async function getBureauUser() {
  const endpointEditarItem = endPoints.obterDadosCadastraisDoUsuarioParaSanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.get<IBureauUser>(
    endpointEditarItem
  )

  return response
}

export async function updateContacts(data: IUserContact) {
  const endpointEditarItem = endPoints.atualizarContatoDoUsuarioParaSanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.patch<IGenericResponse>(
    endpointEditarItem,
    data
  )

  return response
}

export async function validateMFA(data: IMFARequest) {
  const endpointEditarItem = endPoints.validarMFASanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.post<IGenericResponse>(
    endpointEditarItem,
    data
  )

  return response
}

export async function sendCodeMFA() {
  const endpointEditarItem = endPoints.solicitarEnvioMFASanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.post<IGenericResponse>(
    endpointEditarItem
  )

  return response
}

export async function finalizeSanitization() {

  const empregadorId = JSON.parse(sessionStorage.getItem('empregadorId') ?? '""');

  const endpointEditarItem = endPoints.finalizarSanitizacao
    .replace('{id}', getUserIdByToken)

  const response = await API_DOMAIN_ACCESS.post<IGenericResponse>(
    endpointEditarItem,
    {
      accountId: empregadorId
    }
  )

  return response
}

export async function getMigrationStatus(): Promise<IUserMigrationStatus> {

  const endpointSanitization = endPoints.userMigrationStatus.replace(
    '{id}',
    getUserIdByToken
  )

  const data = await API_DOMAIN_ACCESS.get<IUserMigrationStatus>(
    endpointSanitization
  )

  return data;
}
